import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function DailyCompetition() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[400px] md:h-[500px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20shot%20of%20vibrant%20neon%20sign%20district%20at%20night%20with%20multiple%20glowing%20signs%20in%20various%20warm%20colors%20reflecting%20on%20wet%20pavement%2C%20bustling%20urban%20entertainment%20district%20atmosphere%2C%20cinematic%20photography%20with%20deep%20shadows%20and%20colorful%20light%20accents%20creating%20energetic%20nightlife%20mood&width=1600&height=700&seq=daily-cta&orientation=landscape"
        alt="每日大赛"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60" />

      <div className="absolute inset-0 flex flex-col justify-between p-6 md:p-12 lg:p-16 z-10">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white drop-shadow-lg">
          {t('dailyTitle')}
        </h2>

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <p className="text-sm md:text-base text-white/90 max-w-md leading-relaxed drop-shadow-md">
            {t('dailyDesc1')}
            <br />
            {t('dailyDesc2')}
          </p>
          <Link
            to="/category/meiri-dasai"
            className="inline-flex items-center gap-3 px-5 py-3 bg-white text-black rounded-full text-sm font-medium hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer w-fit shadow-lg"
          >
            {t('dailyCta')}
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-black text-white">
              <i className="ri-arrow-right-line text-xs" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}